import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listPageData: [],
};

export const listPageSlice = createSlice({
    name: "listPage",
    initialState,
    reducers: {
        addListPageData: (state, action) => {
            state.listPageData = action?.payload;
        },
    },
});

export const { addListPageData } = listPageSlice.actions;
export default listPageSlice.reducer;
